import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const customFontSize = '14px';

const rowStyle = {
  fontSize: customFontSize,
  color: colors.black,
  fontWeight: fonts.weights.normal,
  letterSpacing: '0.25px',
  lineHeight: '20px',
};

const useStyles = makeStyles({
  accordionContainer: {
    '& .MuiAccordionDetails-root': {
      padding: 0,
    },
  },
  accordionSummary: {
    backgroundColor: colors.planningGridAccordionSumaryBg,
    minHeight: '72px',
  },
  buttonsActionsContainer: {
    display: 'flex',
    width: '100%',

    '& .MuiButton-text': {
      fontSize: customFontSize,
      fontWeight: fonts.weights['extra-bold'],
      letterSpacing: '1.25px',
      lineHeight: '16px',
    },
  },
  buttonsActionsContainerLeft: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
  },
  buttonsActionsContainerRight: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  container: {
    background: colors.white,
    width: '100%',

    '& .MuiTable-root': {
      borderCollapse: 'collapse',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      background: '#fff',
      zIndex: 999,
      boxShadow:
        'inset 0 1px 0 1px solid rgba(224, 224, 224, 1), inset 0 -1px 0 1px solid rgba(224, 224, 224, 1)',
    },
    // Table root
    '& > div:first-child': {
      height: '100%',
      paddingBottom: '16px',
    },
    // Table container
    '& > div:first-child > div': {
      width: '100%',
      maxHeight: '70vh',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    '& .MuiTableCell-root': {
      ...rowStyle,
      maxHeight: '64px',
      wordWrap: 'break-word',
    },
    '& .Mui-checked': {
      color: colors.primary,
    },
  },
  selectedRows: {
    backgroundColor: colors.primary02,
    borderLeft: `1px solid ${colors.primary}`,
  },
  tableTitle: {
    fontSize: customFontSize,
    color: colors.black,
    fontWeight: fonts.weights.medium,
    letterSpacing: '0.1px',
    lineHeight: '24px',
  },
  tooltipLabel: {
    ...rowStyle,
    color: colors.white,
  },
  tooltipCenterContent: {
    textAlign: 'center',
    width: '100%',
  },
  iconButtonContainer: {
    padding: 0,
  },
  scrollDiv: {
    width: '100%',
    overflowX: 'auto',
  },
  hiddenScrollDiv: {
    height: '1px',
  },
  buttonText: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    textTransform: 'none',
    color: colors.primary,
    textDecoration: 'underline',

    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: colors.white,
    },
  },
});

export default useStyles;
